/**
 * 根据子级id获取路径
 * @param value 子级id
 * @param dataSource 源数据
 * @param path
 * @returns 返回父级value及对应索引
 */
export function findPathByValue(value, dataSource, path) {
  if (path === undefined) {
    path = [];
  }
  for (var i = 0; i < dataSource.length; i++) {
    var tmpPath = path.concat();
    tmpPath.push({
      key: dataSource[i].value,
      index: i
    });
    if (value == dataSource[i].value) {
      return tmpPath;
    }
    if (dataSource[i].children) {
      var findResult = findPathByValue(value, dataSource[i].children, tmpPath);
      if (findResult) {
        return findResult;
      }
    }
  }
}